// extracted by mini-css-extract-plugin
module.exports = {"item":"EvaneosLoginForm_item__xHpsp","rememberWrapper":"EvaneosLoginForm_rememberWrapper__UJWop","submit":"EvaneosLoginForm_submit__BdJbX"};